/**
 * context for blocks in constructed-block and cards in card-layout-block
 */
import React from 'react';
export const BlockContext = React.createContext({});
//# sourceMappingURL=block-context.js.map